import { atom } from "jotai";
import { cursorAtom } from "./cursorAtom";
import { deselectAllNodesSetter } from "../nodes";
import {
  selectedNodeTypeAtom,
  SelectableNodeTypes,
} from "./selectedNodeTypeAtom";
import { isMoreMenuOpenAtom } from "./isMoreMenuOpenAtom";

export const selectNodeTypeSetter = atom(
  null,
  (get, set, nodeType: SelectableNodeTypes) => {
    set(deselectAllNodesSetter);

    const selectedNodeType = get(selectedNodeTypeAtom);

    if (nodeType === selectedNodeType) {
      set(selectedNodeTypeAtom, null);
    } else {
      set(cursorAtom, "select");
      set(selectedNodeTypeAtom, nodeType);

      // Close "more" when a node type is selected from the DiagrammingToolbar
      set(isMoreMenuOpenAtom, false);
    }
  },
);

selectNodeTypeSetter.debugLabel = "selectNodeTypeSetter";
